import { api } from "@/lib/api";

let cached = null;

export function fetchPacks(force = false) {
  if (!cached || force) cached = api.get("/packs").then((r) => r.data?.items || []).catch(() => []);
  return cached;
}
